import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from "gatsby";
import * as b from "../bootstrap.module.css";
import NonBankLoanContents from './content-column/non-bank-loan-contents';
import InstallmentLoanProducts from './product-column/installment-loan-products';
import InstallmentLoanContents from './content-column/installment-loan-contents';
import PaydayLoanProducts from './product-column/payday-loan-products';
import PaydayLoanContents from './content-column/payday-loan-contents';
import NonBankCardProducts from './product-column/non-bank-card-products';
import NonBankCardContents from './content-column/non-bank-card-contents';
import Icon from "../icon.tsx";
import useMedia from '../../hooks/useMedia';
import ConsumerLeasingProducts from './product-column/consumer-leasing-products';
import ConsumerLeasingContents from './content-column/consumer-leasing-contents';

const NonBankLoansNavigation = ({ activeNavigation, changeNavigation }) => {
  const { categories } = useStaticQuery(graphql`
    query NonBankLoansTopNavigation {
      categories: allMysqlTerms(filter: {cluster: {in: ["firms_1", "firms_2", "firms-cards", "consumer-leasing"]}}) {
        nodes {
          term
          term_normalized
          path
          cluster
          menu_icon
        }
      }
    }
  `);

  const [activeTab, setActiveTab] = useState('');
  const isMobileResolution = useMedia(['(max-width: 992px)'], [true], false);

  const changeTab = (cluster) => setActiveTab(activeTab !== cluster ? cluster :  '');
  const previousStep = () => {
    if (activeTab) {
      setActiveTab('');
    } else if (activeNavigation) {
      changeNavigation('');
    }
  };

  useEffect(() => {
    if (activeNavigation !== 'localfirms_2') {
      setActiveTab('');
    }
  }, [activeNavigation]);

  if (!categories.nodes.length) {
    return null;
  }

  return (
    <div className={['top-navigation-tabs', activeNavigation !== 'localfirms_2' ? b.dNone : '', activeTab ? 'active' : ''].join(' ')}>
      <div className="top-navigation-links">
        {isMobileResolution ? (<>
          <button onClick={previousStep} className="top-navigation-prev-step">
            <span className={[b.container, b.dFlex, b.alignItemsCenter].join(' ')}>
              <span className={b.pr1}>
                <Icon icon="Angle-left" size={24} color="#2B2B2B" />
              </span>

              <span>
                Cofnij do
                <strong>{activeTab ? 'pożyczek pozabankowych' : 'menu głównego'}</strong>
              </span>
            </span>
          </button>

          {!activeTab && <strong className="top-navigation-title">Pożyczki pozabankowe</strong>}

          <div className={b.pt1}>
            {categories.nodes.filter((category) => !activeTab || activeTab === category.cluster).map((category, i) => (
              <button 
                key={i} 
                onClick={() => changeTab(category.cluster)}
                className={["top-navigation-link", "top-navigation-link-arrow", activeTab === category.cluster ? 'active' : ''].join(' ')}
              >
                <span className="top-navigation-link-icon">
                  <Icon icon={category.menu_icon} size={34} />
                </span>

                {category.term}
              </button>
            ))}
          </div>
        </>) : (<>
          <strong className="top-navigation-title">Pożyczki pozabankowe</strong>
        
          <div className={[b.mt2, b.pt1].join(' ')}>
            {categories.nodes.map((category, i) => (
              <button 
                key={i} 
                onClick={() => changeTab(category.cluster)}
                className={["top-navigation-link", "top-navigation-link-arrow", activeTab === category.cluster ? 'active' : ''].join(' ')}
              >
                <span className="top-navigation-link-icon">
                  <Icon icon={category.menu_icon} size={34} />
                </span>

                {category.term}
              </button>
            ))}
          </div>
        </>)}
      </div>
      
      <div className="top-navigation-products">
        {[['', NonBankLoanContents], ['firms_1', PaydayLoanProducts], ['firms_2', InstallmentLoanProducts], ['firms-cards', NonBankCardProducts], ['consumer-leasing', ConsumerLeasingProducts]].map(([tab, Component], i) => (
          <div key={i} className={activeTab === tab ? '' : b.dNone}>
            <Component active={activeTab === tab} />
          </div>
        ))}
      </div>
      
      <div className={["top-navigation-contents", activeTab === '' ? b.dNone : ''].join(' ')}>
        {[['firms_1', PaydayLoanContents], ['firms_2', InstallmentLoanContents], ['firms-cards', NonBankCardContents], ['consumer-leasing', ConsumerLeasingContents]].map(([tab, Component], i) => (
          <div key={i} className={activeTab === tab ? '' : b.dNone}>
            <Component active={activeTab === tab} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default NonBankLoansNavigation;